"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ typography }) => ({
    root: {
        flex: 1,
        '& *': {
            fontFamily: typography.fontFamily
        }
    }
});
//# sourceMappingURL=styles.js.map